<div id='report-container' >
    <div *ngIf="loading" class="graph loading"  [chart]="chart"></div>
    <div *ngIf="!loading" class="graph" [chart]="chart"></div>
</div>